import { useMutation } from '@apollo/client';
import { REQUEST_ATHLETE_CONNECTION } from '../../apollo/mutations/coachRequest';
import { SEND_INVITE } from '../../apollo/mutations/user';

export const useInviteAthlete = () => {
  const [requestConnection] = useMutation(REQUEST_ATHLETE_CONNECTION);
  const [sendInvite] = useMutation(SEND_INVITE);

  const inviteAthlete = async (email) => {
    try {
      const response = await requestConnection({ variables: { email } });
      return { type: 'connection', data: response.data?.requestAthleteConnection };
    } catch (err) {
      if (err.message.includes('Athlete with that email not found')) {
        await sendInvite({ variables: { email, role: 'athlete' } });
        return { type: 'invite' };
      }
      throw err;
    }
  };

  return { inviteAthlete };
};
